__turbopack_context__.v({
  "segmentItem": "SegmentItem-module__J_4clW__segmentItem",
  "segmentItemActive": "SegmentItem-module__J_4clW__segmentItemActive",
});
